module.exports = __webpack_public_path__ + "DINNextLTPro-Heavy.eot?4183fa1e988952cb265a44c084670a21";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Heavy.eot
// module id = 313
// module chunks = 0